import ServiceSurveyDialog from './ServiceSurveyDialog';

export default ServiceSurveyDialog;
